/* * ***********************************************************
 * * This piece of information is originated by and the
 * * * intellectual property of Esri China (Hong Kong) Limited.
 * * ***********************************************************
 * Name of Code Originator : Sunny To
 * Creation Date : 2021-10-06
 * Description/Purpose : This component provides an interface for dialogue window displaying
 * Required Inputs : N/A
 * Expected Outputs : N/A
 */
import IComponent from "./IComponent";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { styled } from "@material-ui/core/styles";

const GInfoDialog = styled(Dialog)(({ theme }) => ({
  // "& .MuiPaper-root": {
  //   marginTop: 0,
  //   paddingTop: 0,
  //   position: "absolute",
  //   top: 0,
  // },
}));

const DIALOG_STYLES = {
  dialogWindow: {},
  dialogTitle: {
    //color: "var(--bodyText)",
    //margin: "60px auto 5px auto",
    padding: 0,
  },
  dialogContent: {
    width: "623px",
    marginBottom: "30px",
    overflow: "visible",
    padding: 0,
    //olor: "var(--bodyText)",
  },
  dialogContentText: { margin: "5px" },
  dialogButtons: {
    borderTop: "1px solid var(--uiColor2)",
    padding: "15px 44px 0 44px",
    marginBottom: "15px",
  },
  dialogIconContainer: {
    width: "50px",
    height: "50px",
    textAlign: "center",
    margin: "10px",
  },
  dialogIcon: { width: "100%", height: "100%" },
};

// TODO: Update the icon class name when Naomi provided us the icons
const DIALOG_ICONS = {
  prompt: "icn_message_question",
  info: "icn_message_info",
  error: "icn_message_error",
  success: "icn_message_confirm",
};

class ShowDialog extends IComponent {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }
  handleClickOpen = () => {
    this.setState({
      isOpen: true,
    });
  };

  handleClose = async (callback) => {
    var closeResult = await callback();
    if (typeof closeResult != "undefined" && closeResult === false) return;
    if (typeof closeResult === "object" && "transitDialog" in closeResult) {
      // current?.writeStore("openDialog", {
      //   ...closeResult.transitDialog,
      //   isOpen: true,
      //   jsxElement: <CircularProgress size={30} />,
      // });
      // return;
    }
    this.props.dialogSetup.isOpen = false;
    this.setState({});
  };

  render() {
    let dialogType = this.props.dialogSetup?.type || "info";
    return (
      <GInfoDialog
        style={{ ...DIALOG_STYLES.dialogWindow }}
        open={this.props.dialogSetup?.isOpen || false}
        aria-labelledby="responsive-dialog-title"
        // fullWidth={!(typeof this.props.dialogSetup?.size == "undefined")}
        maxWidth={false}
      >
        <div
          className="EqualWidthChildren"
          style={{
            borderTop: `5px solid var(--${dialogType}`,
            padding: "20px 50px",
            alignItems: "start",
          }}
        >
          <div style={DIALOG_STYLES.dialogIconContainer}>
            <span
              className={DIALOG_ICONS[dialogType]}
              style={{
                ...DIALOG_STYLES.dialogIcon,
                filter: "none",
              }}
            />
          </div>
          <div>
            <DialogTitle style={DIALOG_STYLES.dialogTitle}>
              {this.props.dialogSetup?.title}
            </DialogTitle>
            <DialogContent style={DIALOG_STYLES.dialogContent}>
              <div style={DIALOG_STYLES.dialogContentText}>
                {this.props.dialogSetup?.content}
              </div>
              <div style={DIALOG_STYLES.dialogContentText}>
                {this.props.dialogSetup?.jsxElement}
              </div>
            </DialogContent>
          </div>
        </div>

        <DialogActions
          className="EqualWidthChildren"
          style={DIALOG_STYLES.dialogButtons}
        >
          <Button
            style={{
              marginRight: "5px",
              display: this.props.dialogSetup?.onDialogCancel ? "" : "none",
            }}
            onClick={() =>
              this.handleClose(this.props.dialogSetup?.onDialogCancel)
            }
            variant="outlined"
            classes={{ root: "actionBtn" }}
            disabled={this.props.dialogSetup?.disableCancelBtn}
          >
            {this.props.dialogSetup?.cancelButtonText || "Cancel"}
          </Button>
          <Button
            style={{
              marginLeft: "5px",
              display: this.props.dialogSetup?.onDialogOk ? "" : "none",
            }}
            onClick={() => this.handleClose(this.props.dialogSetup?.onDialogOk)}
            color="primary"
            variant="contained"
            classes={{ root: "actionBtn" }}
            disabled={this.props.dialogSetup?.disableOkBtn}
          >
            {this.props.dialogSetup?.okButtonText || "OK"}
          </Button>
        </DialogActions>
      </GInfoDialog>
    );
  }
}

export default ShowDialog;
